import React from 'react'
import { locationArrangementStatusChoices } from 'services/cfg/form'
import { translate } from 'services/i18n'
import KToolTip from 'ui-shared/KTooltip'
import { useFormContext } from 'react-hook-form'
import { LocationArrangementName } from 'types/form'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'

type Props = {
  name: LocationArrangementName
}

const SingleArrangementInput: React.FC<Props> = ({ name }) => {
  const { setValue, watch } = useFormContext()
  const status = watch(`arrangements.${name}.status`)

  const disableParticipantsInput = status === 'inactive' || status === 'hidden'

  if (status !== 'active') setValue(`arrangements.${name}.capacity`, 0)

  return (
    <div>
      <div>{translate(`form.fields.${name}Arrangement`)}</div>
      <div style={{ display: 'flex' }}>
        <KToolTip
          title="tooltip.hint.locationArrangementStatus"
          placement="top"
        >
          <KSelectInput
            choices={locationArrangementStatusChoices}
            label="Status"
            source={`arrangements.${name}.status`}
            style={{ marginRight: '24px' }}
          />
        </KToolTip>
        <KToolTip title="tooltip.hint.locationArrangementCapacity">
          <KNumberInput
            source={`arrangements.${name}.capacity`}
            label="form.fields.maxParticipants"
            disabled={disableParticipantsInput}
          />
        </KToolTip>
      </div>
    </div>
  )
}

export default SingleArrangementInput
